var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"px-4"},[(_vm.items[0])?_c('article-card',_vm._b({attrs:{"size":"lg"},on:{"click":function($event){return _vm.$emit('click-item', _vm.items[0])},"delete":function($event){return _vm.$emit('delete-item', _vm.items[0])}}},'article-card',_vm.items[0],false)):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }